export default __webpack_public_path__ + "static/media/MarkerKFC.90649463.svg";